
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};
var WPO = {
    speed: noop,
    error: noop,
    retCode: noop,
    custom: noop,
    log: noop
};

function getWPO() {
    if (typeof window !== 'undefined' && window.__WPO) {
        WPO = window.__WPO;

        getWPO = function getWPO() {
            return WPO;
        };
    }

    return WPO;
}

/**
 * RetCode 对象, 封装计时逻辑, 减轻对业务代码的污染
 */

var RetCode = exports.RetCode = function () {
    function RetCode(api) {
        _classCallCheck(this, RetCode);

        this.api = api;
        this.startTime = new Date().getTime();
    }

    /**
     * 返回码统计
     * @param isSuccess
     * @param msg
     */

    _createClass(RetCode, [{
        key: 'finish',
        value: function finish(isSuccess, msg) {
            var endTime = new Date().getTime();
            var delay = endTime - this.startTime;
            getWPO().retCode(this.api, isSuccess, delay, msg);
        }

        /**
         * 返回码统计
         * @param isSuccess
         * @param msg
         */

    }, {
        key: 'retCode',
        value: function retCode(api, isSuccess, delay, msg) {
            getWPO().retCode(api, isSuccess, delay, msg);
        }

        /**
         * 自定义日志
         * @param category
         * @param key
         * @param value
         */

    }, {
        key: 'custom',
        value: function custom(category, key, value) {
            getWPO().custom(category, key, value);
        }

        /**
         * 错误信息统计
         * @param category
         * @param msg
         */

    }, {
        key: 'error',
        value: function error(category, msg) {
            getWPO().error(category, msg);
        }

        /**
         * 日志接口
         * @param msg 日志信息
         * @param sampling 抽样率
         */

    }, {
        key: 'log',
        value: function log(msg, sampling) {
            getWPO().log(msg, sampling);
        }

        /**
         * 测速接口
         * @param pos
         * @param delay
         * @param _immediately
         */

    }, {
        key: 'speed',
        value: function speed(pos, delay, _immediately) {}
    }, {
        key: 'success',
        value: function success() {
            var msg = arguments.length <= 0 || arguments[0] === undefined ? '接口调用成功' : arguments[0];

            this.finish(true, msg);
        }
    }, {
        key: 'failed',
        value: function failed() {
            var msg = arguments.length <= 0 || arguments[0] === undefined ? '接口调用失败' : arguments[0];

            this.finish(false, msg);
        }
    }]);

    return RetCode;
}();

var report = {
    retCode: function retCode(api) {
        return new RetCode(api);
    }
};

exports.default = report;